module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0051.jpg?v=adce7c26";